import React from 'react';
import {withStyles} from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import PlayrateTooltipLabel from '../components/chart/PlayrateTooltipLabel';
import PlayrateTooltipLegend from '../components/chart/PlayrateTooltipLegend';
import useLocalization from '../../../../../hooks/useLocalization';
import useDurationFormatter from '../hooks/useDurationFormatter';

export const PLAYRATE_HIGHLIGHT_HIGHT = 147;

const CODES = {
    xAxisLabel: 'epic.affiliate.fortnite_games.playrate.xaxis_label',
    highlightLabel: 'epic.affiliate.fortnite_games.playrate.tooltip.label'
};

const StyledHighlightsWrapper = withStyles(theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        marginBottom: theme.spacing(1.5)
    }
}))(Box);

const StyledTicksWrapper = withStyles(theme => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between'
    }
}))(Box);

const StyledLabel = withStyles(theme => ({
    root: {
        fontSize: '12px',
        margin: theme.spacing(1, 0),
        color: theme.palette.dividerStrong
    }
}))(Typography);

const StyledTickContainer = withStyles(theme => ({
    root: {
        display: 'flex',
        justifyContent: 'flex-end',
        height: '100px',
        width: '100%',
        marginTop: theme.spacing(2)
    }
}))(Box);

const StyledTick = withStyles(theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '200px',
        marginLeft: theme.spacing(2),
        padding: theme.spacing(2),
        borderRadius: '4px 0 4px 4px',
        background: '#333333',

        '&::before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            width: 0,
            height: 0,
            border: '10px solid transparent',
            borderTop: 0,
            borderRight: '20px solid #333333',
            transform: 'scaleY(-1) translate(160px, 20px)'
        }
    }
}))(Box);

const PlayrateHighlights = ({viewBox: {x, y, width, height}, offset, data = []}) => {
    const getMessage = useLocalization();
    const formatDuration = useDurationFormatter();

    return (
        <g>
            <foreignObject
                x={x}
                y={y + height + offset}
                width={width}
                height={PLAYRATE_HIGHLIGHT_HIGHT}>
                <StyledHighlightsWrapper>
                    <StyledLabel variant="body2" align="center">
                        {getMessage(CODES.xAxisLabel)}
                    </StyledLabel>
                    <StyledTicksWrapper>
                        {data.map(({percentage, current, previous}) => (
                            <StyledTickContainer key={percentage}>
                                <StyledTick
                                    style={{
                                        transform:
                                            percentage === 95
                                                ? `translateX(-${width / 20}px)`
                                                : 'unset'
                                    }}>
                                    <PlayrateTooltipLabel label={percentage} />
                                    <PlayrateTooltipLegend
                                        color="#339BFF"
                                        value={formatDuration(current)}
                                    />
                                    <PlayrateTooltipLegend
                                        color="#FFA640"
                                        value={formatDuration(previous)}
                                    />
                                </StyledTick>
                            </StyledTickContainer>
                        ))}
                    </StyledTicksWrapper>
                </StyledHighlightsWrapper>
            </foreignObject>
        </g>
    );
};

export default PlayrateHighlights;
